import { useState } from 'react';
import { FiSearch } from 'react-icons/fi';
import Journal from '../components/Journal';
import './Blog.css';
export default function Blog() {
  const [search, setSearch] = useState('');
  return <div className="blog-container container">
    <header className="journal-page-header"><p className="eyebrow">The journal / Adrian Obadiah</p><h1>A few thoughts.<br /><span>A little perspective.</span></h1><p>Notes on development, creativity, and the things I learn while building.</p></header>
    <div className="journal-toolbar"><span>STORIES & IDEAS</span><label className="journal-search"><FiSearch aria-hidden="true" /><span className="sr-only">Search articles</span><input type="search" value={search} onChange={event => setSearch(event.target.value)} placeholder="Find a story…" /></label></div>
    <Journal search={search} />
  </div>;
}
